import React from 'react';
import Skeleton, { SkeletonType } from '.';

const SkeletonThumbnail = () => {
  return (
    <div className='skeleton-thumbnail skeleton-wrapper'>
      <Skeleton type={SkeletonType.thumbnail} />
      <div className='shimmer-wrapper'>
        <div className='shimmer'></div>
      </div>
    </div>
  );
};

export default SkeletonThumbnail;
